import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "electron-note-header electron-drag" }
const _hoisted_2 = { class: "text-deEmphasised-text" }
const _hoisted_3 = { class: "text-text-default" }

import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'ElectronNoteHeader',
  setup(__props) {

const { iconPath, getCustomIconStyle } = useCustomIcon();
const { translate } = useTranslate();

const seeAllNotes = () => {
  //@ts-ignore
  window.electron.send('change-route-channel', {
    path: 'notes',
    closeCard: true, // closes card when opening new route
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(translate)('autoSaved')), 1),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createElementVNode("div", {
      class: "flex items-center h-6 px-2 gap-x-1 cursor-pointer hover:bg-hover-default rounded electron-no-drag",
      onClick: seeAllNotes
    }, [
      _createElementVNode("em", {
        class: "custom-icons",
        style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('note')))
      }, null, 4),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(translate)('seeAllNotes')), 1)
    ])
  ]))
}
}

})